import { PULSE_CACHE_KEYS, PULSE_CACHE_KEY_PREFIXES } from './cache-keys';
import { invalidateCache } from './query-cache';

export const invalidateTracksCache = (): void => {
  invalidateCache(PULSE_CACHE_KEYS.tracks);
  invalidateCache(PULSE_CACHE_KEY_PREFIXES.trackDetails);
  invalidateCache(PULSE_CACHE_KEY_PREFIXES.trackHistory);
  invalidateCache(PULSE_CACHE_KEY_PREFIXES.insights);
};

export const invalidateResultCaches = (checkId: string): void => {
  invalidateCache(PULSE_CACHE_KEYS.checkDetails(checkId));
  invalidateCache(PULSE_CACHE_KEY_PREFIXES.checkHistory(checkId));
  invalidateCache(PULSE_CACHE_KEY_PREFIXES.resolvedValues(checkId));
  invalidateCache(PULSE_CACHE_KEY_PREFIXES.trackChecks);
  invalidateCache(PULSE_CACHE_KEY_PREFIXES.trackDetails);
  invalidateCache(PULSE_CACHE_KEY_PREFIXES.trackHistory);
  invalidateCache(PULSE_CACHE_KEY_PREFIXES.insights);
  invalidateCache(PULSE_CACHE_KEY_PREFIXES.integrationHealth);
};
